import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material"; 
import React from "react";
import {
  Box,
  P,
  SectionSmallHeading,
  SectionSubHeading,
  SectionWrapper,
} from "../../../styles";

const TokenomicsImg = styled(Grid)`
  display: flex;
  align-self: self-end;
  text-align: center;
  /* justify-content: center; */
  @media screen and (max-width: 899px) {
    justify-content: center;
  }
`;
const CustomGrid = styled(Grid)`
  width: 50%;
  @media screen and (max-width: 832px) {
    width: 100%;
  }
`;
const Div = styled.div`
  display: flex;
  justify-content: center;
`;
const Heading = styled.h5`
  font-weight: 600;
  margin-top: 5px;
  margin-bottom: ${(props) => (props.mb ? props.mb : "5px")};
  font-size: 23px;
`;
const Text = styled.span`
  font-size: ${(props) => (props.fs ? props.fs : "20px")};
  font-weight: 200;
  font-size: 18px;
  @media screen and (max-width: 480px) {
    /* font-size: 16px; */
  }
  @media screen and (max-width: 330px) {
    /* font-size: 12px; */
  }
`;

const index = () => {
  return (
    <div>
      <SectionWrapper pb="4rem" pt650px="50px">
        <Container maxWidth="xl" id="tokenomics">
          <Grid container>
            <Grid xs={12}>
              <SectionSubHeading tc="center">Tokenomics</SectionSubHeading>
              <Div>
                <CustomGrid container spacing={0.3}>
                  <Grid item xs={12}>
                    <Box mh="70px" align="center" padding="10px">
                      <Heading fs="20px">
                        Total supply: <Text fs="20px">1 Million</Text>
                      </Heading>
                    </Box>
                  </Grid>
                  {/* <Grid item xs={6}>
                    <Box mh="70px" align="center" padding="10px">
                      <Heading fs="25px">
                        Liquidity: <Text fs="20px"> 3%</Text>
                      </Heading>
                    </Box>
                  </Grid> */}
                  <Grid item xs={6}>
                    <Box mh="80px" mt="0px" align="center">
                      <P fs="20px" mt="0px" mb="0px" align="center">
                        Buy/Sell tax: 6%
                      </P>
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box mh="80px" mt="0px" align="center">
                      <P fs="20px" mt="0px" mb="0px" align="center">
                        100% Auto Liquidity
                      </P>
                    </Box>
                  </Grid>

                  <Grid item xs={12}>
                    <Box mt="0px" align="center">
                      {/* <Heading mb="0px" fs="25px">
                        Slippage
                      </Heading> */}
                      {/* <P mt="0px" mb="0px" align="center">
                        Buy/Sell tax: 6%
                      </P>
                        3% Auto Liquidity,
                        <br /> */}
                      <P fs="20px" mb="0px" mt="0px" align="center">
                        3% Marketing/Dev/BuyBack{" "}
                      </P>
                    </Box>
                  </Grid>
                </CustomGrid>
              </Div>
            </Grid>
          </Grid>
        </Container>
      </SectionWrapper>
    </div>
  );
};

export default index;
